import httpUtil from '@/frame/httpUtil.js'

export const checkSSO = () => {
  return new Promise((resolve, reject) => {
    httpUtil.ajax({
      url: 'getKeyclockConfig',
      isNoAlertMsg: true
    }).then(({ returndata }) => {
      const { url, enable } = returndata
      enable ? resolve({url}) : resolve(false)
    }).catch(() => {
      // 走正常登录
      reject()
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/ssoHandle.js